<script>
import { defineComponent } from "@vue/composition-api";

export default defineComponent({
  name: "ApproverPhones",
  model: {
    prop: "modelValue",
    event: "on-change-model-value",
  },
  emit: ["on-change-input"],
  props: {
    modelValue: {
      type: Array,
      default: () => [],
    },
  },
  setup(props, { emit }) {
    const handleApproverPhone = (type, index) => {
      if (type === "add") {
        const phoneObj = { name: "", phone: "" };
        props.modelValue.push(phoneObj);
      } else {
        props.modelValue.splice(index, 1);
      }
    };

    // 输入内容切换事件
    const handelChangeInput = () => {
      emit("on-change-input");
    };

    return {
      handleApproverPhone,
      handelChangeInput,
    };
  },
});
</script>

<template>
  <div class="approver-phones">
    <div v-for="(item, index) in modelValue" :key="index" class="input-item">
      <a-input v-model="item.name" placeholder="请输入审批人名称" @change="handelChangeInput" />
      <a-input v-model="item.phone" placeholder="请输入审批人手机号" @change="handelChangeInput" />
      <a-icon type="plus-circle" @click="handleApproverPhone('add')" />
      <a-icon v-if="index" type="minus-circle" @click="handleApproverPhone('remove', index)" />
    </div>
  </div>
</template>

<style lang="less" scoped>
.approver-phones {
  .input-item {
    display: flex;
    align-items: center;
    margin-bottom: 16px;

    &:nth-last-child(1) {
      margin-bottom: 0;
    }

    /deep/.ant-input {
      width: 257px;
      margin-right: 10px;
    }

    i {
      cursor: pointer;
      color: #7e8694;
    }

    i:nth-of-type(1) {
      margin-right: 16px;
    }
  }
}
</style>
